import React, { FC, ReactElement, useCallback, useState } from 'react';

import JobApplicationMessageForm, {
  ModalProps
} from '@buyside/components/presentation/JobApplicationShowPage/JobApplicationShowModal/ModalParts/JobApplicationMessageForm';
import Modal from '@buyside/components/presentation/Modal/modal';
import TooltipWhite from '@buyside/components/presentation/Tooltips/TooltipWhite/tooltipWhite';

import styles from './JobApplicationShowModalStyles.scss';

const AcceptModal: FC<ModalProps & { interviewed?: boolean }> = ({
  handleSubmit,
  interviewed = false,
  name,
  renderOpenButton
}): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => setIsModalOpen(true), []);

  return (
    <>
      {interviewed ? (
        <span>{renderOpenButton(handleOpenModal)}</span>
      ) : (
        <TooltipWhite
          overlay={<div>Message this candidate regarding a job interview</div>}
          placement="top"
        >
          <span>{renderOpenButton(handleOpenModal)}</span>
        </TooltipWhite>
      )}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Send Interview Request"
      >
        <div className={styles.subtitle}>Please enter a message to {name}</div>
        <JobApplicationMessageForm
          closeModal={() => setIsModalOpen(false)}
          handleSubmit={handleSubmit}
          submitButtonText="Send Interview Request"
        />
        <div className={styles.note}>
          <strong>Note: </strong>In no way does this interview request constitute an offer of
          employment.
        </div>
      </Modal>
    </>
  );
};

export default AcceptModal;
